import { OneEyeService } from './api'


const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const getDestination = async (userType='E') => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/Destination/usertypes/${userType}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getDestinationById = async (id) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/Destination/${id}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const CreateDestination = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/Destination
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}
export const UpdateDestination = async (req) => {
    try {
        return await OneEyeService.put(`${krtiWebUrl}/Destination/${req.id}
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const CreateCategory = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/category/add-update-category
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const CategoryStatusupdate = async (req) => {
    // const {i} = payload
    try {
        return await OneEyeService.post(`${krtiWebUrl}/category/statusUpdate/${req?.id}/${req?.status}/
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const GetMerchantCategory = async (selectedMerchant) => {

    try {
        return await OneEyeService.get(`${krtiWebUrl}/category/getmerchantCategory/${selectedMerchant}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}